<template>
  <div class="home">
    <h2>Platforms</h2>

    <b-button @click="raisePopup({ target: $event.target })" variant="primary">
      Add new
    </b-button>

    <!-- Info modal -->
    <b-modal
      id="platformsModal"
      v-bind:title="this.isEdit ? 'Edit platform' : 'New platform'"
      @ok="platformFormSubmit"
    >
      <b-form>
        <input id="newPlatformInput0" type="hidden" v-model="form.id" />
        <b-form-group
          id="newPlatformInputGroup1"
          label="Name:"
          label-for="newPlatformInput1"
        >
          <b-form-input
            id="newPlatformInput1"
            type="text"
            v-model="form.name"
            placeholder="Enter Name"
          />
        </b-form-group>

        <b-form-group
          id="newPlatformInputGroup4"
          label="Max version:"
          label-for="newPlatformInput4"
        >
          <Dropdown
            placeholder="Max app version allowed in SEMVER format XX.YY.ZZ"
            v-model="form.maxVersion"
            :list="$store.state.versions"
          />
        </b-form-group>
      </b-form>
    </b-modal>

    <b-container fluid>
      <!-- User Interface controls -->
      <!--<b-row>-->
      <!--<b-col md="12" class="my-1">-->
      <!--<b-form-group label-cols-sm="1" label="Filter" class="mb-0">-->
      <!--<b-input-group>-->
      <!--<b-form-input v-model="filter" placeholder="Type to Search" />-->
      <!--<b-input-group-append>-->
      <!--<b-button :disabled="!filter" @click="filter = ''"-->
      <!--&gt;Clear</b-button-->
      <!--&gt;-->
      <!--</b-input-group-append>-->
      <!--</b-input-group>-->
      <!--</b-form-group>-->
      <!--</b-col> </b-row>-->
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="2" label="Sort" class="mb-0">
            <b-input-group>
              <b-form-select v-model="sortBy" :options="sortOptions">
                <option slot="first" :value="null">-- none --</option>
              </b-form-select>
              <b-form-select
                :disabled="!sortBy"
                v-model="sortDesc"
                slot="append"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        small
        hover
        stacked="md"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @filtered="onFiltered"
        ref="platformsTable"
        class="platformsTable"
      >
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            class="m-1"
            @click="row.toggleDetails"
            variant="info"
          >
            …
          </b-button>
          <b-button
            size="sm"
            class="m-1"
            variant="warning"
            @click="
              raisePopup({
                target: $event.target,
                isEdit: true,
                platform: row.item
              })
            "
          >
            ✎
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            @click="
              deletePlatform({
                target: $event.target,
                platform: row.item
              })
            "
          >
            X
          </b-button>
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>

      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */
import Dropdown from '../components/Dropdown';

const originalForm = {
  id: null,
  name: null,
  maxVersion: null
};

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100, 500],
      sortBy: null,
      sortDesc: false,
      filter: null,
      form: {
        ...originalForm
      },
      isEdit: false
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    fields() {
      return [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'maxVersion',
          label: 'Max version allowed',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'createdAt',
          label: 'Created',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'updatedAt',
          label: 'Updated',
          sortable: true,
          class: 'text-center'
        },
        { key: 'actions', label: 'Actions' }
      ];
    },
    totalRows() {
      return this.$store.state.platforms.count;
    }
  },
  methods: {
    raisePopup({ target, isEdit = false, platform = null }) {
      this.isEdit = isEdit;
      if (platform && isEdit) {
        this.form = Object.keys(originalForm).reduce(
          (acc, current) =>
            platform[current]
              ? {
                  ...acc,
                  [current]: String(platform[current])
                }
              : acc,
          {}
        );
      } else {
        this.platformFormReset();
      }
      this.$root.$emit('bv::show::modal', 'platformsModal', target);
    },
    deletePlatform({ platform = null }) {
      if (!platform) {
        return;
      }
      const promise = this.$store.dispatch('deletePlatform', platform.id);

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        this.$refs.platformsTable.refresh();
      });
    },
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.currentPage = 1;
    },
    items(ctx) {
      const promise = this.$store.dispatch('getPlatforms', ctx);

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        return this.$store.state.platforms.rows || [];
      });
    },
    platformFormReset() {
      this.form = { ...originalForm };
    },
    async platformFormSubmit(event) {
      if (!this.isEdit) {
        await this.$store.dispatch('addPlatform', {
          platform: this.form,
          event
        });
      } else {
        await this.$store.dispatch('editPlatform', {
          platform: this.form,
          event
        });
      }

      this.platformFormReset();
      this.$refs.platformsTable.refresh();
    }
  },
  mounted() {
    this.$store.dispatch('getVersions');
  },
  components: { Dropdown }
};
</script>
<style scoped type="text/scss">
.block {
  border-bottom: #dadada 1px solid;
  padding-bottom: 1em;
  margin-bottom: 3em;
}
.container {
  max-width: none;
}
.platformsTable {
  font-size: 0.8rem;
}
.btn {
  font-size: 0.8rem;
}

td[data-label='Actions'] {
  white-space: nowrap;
}
</style>
